// extracted by mini-css-extract-plugin
export default {"cmsPage":"CMSPage_cmsPage__j1p8s"};